module.exports = __webpack_public_path__ + "static/UnclickPersonalAccident-9980d12d25c6874112cb4b892cff2157.png";